/* @ngInject */
function CampaignActionsCarrosselController ($rootScope, $scope, $timeout, CampaignActionService, LocalStorageService) {
  $scope.campaignCount = 0
  $scope.showCampaignHeader = true
  $scope.showCollapsedOption = false

  const api = {
    _getUserActions,
    _checkNavigationButtons,
    _showCollapsedOption,
    _getLocalStorageCollapsedValue
  }
  this.getApi = () => api

  activate()

  function activate () {
    $scope.showLeftButton = false
    $scope.showRightButton = true

    api._getUserActions()

    $timeout(() => {
      const list = document.querySelector('.campaign-actions-carrossel-content .campaign-actions-carrossel-list')
      if (list) {
        list.addEventListener('scroll', () => {
          $scope.$apply(() => {
            api._checkNavigationButtons()
          })
        })

        api._checkNavigationButtons()
      }
    }, 200)
  }

  const deregisterUserActionsRealization = $rootScope.$on('campaign.actions.complete-action', () => {
    api._getUserActions()
  })

  $scope.$on('$destroy', () => {
    deregisterUserActionsRealization()
  })

  $scope.showCongratsMessage = () => {
    if (!$scope.actions) return false
    const availableStatus = ['AVAILABLE', 'TODAY', 'EXPIRED']
    return !$scope.actions.some((action) => availableStatus.includes(action.status))
  }

  async function _getUserActions () {
    const user = await $rootScope.getUser()

    /**
     * Campanhas não são exibidas para consultores e gerentes.
     */
    if (user?.isGroupManager || user?.isGroupOwner) {
      $scope.showCampaignHeader = false
      return
    }

    CampaignActionService.getUserActions().then((response) => {
      $scope.actions = response.actions
      $scope.campaignCount = response.campaignCount
      $timeout(() => {
        api._showCollapsedOption()
      }, 500)
    })
  }

  function _checkNavigationButtons () {
    const list = document.querySelector('.campaign-actions-carrossel-content .campaign-actions-carrossel-list')
    if (!list) return

    $scope.showLeftButton = list.scrollLeft > 0

    const hasMoreContent = Math.ceil(list.scrollWidth - list.clientWidth - list.scrollLeft) > 1
    $scope.showRightButton = hasMoreContent
  }

  $scope.scrollLeft = () => {
    const list = document.querySelector('.campaign-actions-carrossel-content .campaign-actions-carrossel-list')
    if (!list) return

    list.scrollBy({
      left: -300,
      behavior: 'smooth'
    })

    $timeout(() => {
      api._checkNavigationButtons()
    }, 500)
  }

  $scope.scrollRight = () => {
    const list = document.querySelector('.campaign-actions-carrossel-content .campaign-actions-carrossel-list')
    if (!list) return

    list.scrollBy({
      left: 300,
      behavior: 'smooth'
    })

    $timeout(() => {
      api._checkNavigationButtons()
    }, 500)
  }

  $scope.toggleCollapse = () => {
    $scope.isCollapsed = !$scope.isCollapsed
    const value = $scope.isCollapsed ? 1 : 0
    LocalStorageService.set('campaign.actionsCarrosselCollapsed', value)
  }

  function _showCollapsedOption () {
    const allActionsDoneOrSoon = $scope.actions.every((action) => action.status === 'DONE' || action.status === 'SOON')

    if (!allActionsDoneOrSoon) {
      $scope.showCollapsedOption = false
      $scope.isCollapsed = false
      return
    }

    const soonActions = $scope.actions.filter((action) => action.status === 'SOON')
    const todayOrTomorrowActions = soonActions.filter((action) => {
      const publicationDateToUse = action.publicationDate || $scope.campaign.startDate
      const actionPublicationDate = new Date(publicationDateToUse).setHours(0, 0, 0, 0)
      const today = new Date().setHours(0, 0, 0, 0)
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)

      return actionPublicationDate >= today && actionPublicationDate <= tomorrow
    })

    if (!todayOrTomorrowActions.length) {
      $scope.showCollapsedOption = true
      api._getLocalStorageCollapsedValue()
    } else {
      $scope.showCollapsedOption = false
      $scope.isCollapsed = false
    }
  }

  function _getLocalStorageCollapsedValue () {
    const collapsedValue = parseInt(LocalStorageService.get('campaign.actionsCarrosselCollapsed'))
    $scope.isCollapsed = collapsedValue === 1
  }
}

export { CampaignActionsCarrosselController }
